import { useEffect, useState } from 'react';

/** Másodpercenként frissülő aktuális idő — csak az őt használó komponenst rendereli újra. */
export function useClock(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return now;
}
